import React, { Component } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

export default class Zunothankspage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chpiId: sessionStorage.getItem("chpiId"),
      proposalId: sessionStorage.getItem("proposalId"),
      proposalNum: sessionStorage.getItem("proposalNum"),
      baseproductId: sessionStorage.getItem("baseproductId"),
      cqrId: sessionStorage.getItem("cqrId"),
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      zuno_totalAmount: sessionStorage.getItem("totalAmount"),
      policyuuid: sessionStorage.getItem("policyId"),
      policieskyc: [],
      idTYPE: "",
      idNum: "",
      dob: null,
      aadharno: "",
      gender: "",
      name: "",
      ovdType: "",
      filePath: "",
      mobileNum: "",
      email: "",
      pan: "",
      docType: "",
      extension: "pdf",
      frontSide: "",
      proposerType: "I",
      jsonDisplay: null,
      errorMessage: "",
      showAadharForm: false,
      showUploadform: false,
      noPanCard: false,
      startDate: new Date(),
    };
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  componentDidMount() {
    this.apisfetchpolicyHandler();
  }
  apisfetchpolicyHandler = () => {
    var formData = new FormData();
    formData.append("policyId", this.state.policyuuid);

    fetch(configData.api_url + "payments/getzunopolicystatus", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (
          data.status === "success" &&
          data.policy &&
          data.policy.paymentStatus
        ) {
          try {
            const paymentStatus = JSON.parse(data.policy.paymentStatus);

            let statusMsg = "Payment failed!";
            let statusType = "error";

            switch (paymentStatus.AuthStatus) {
              case "0300":
                statusMsg = "Payment Successful!";
                statusType = "success";
                break;
              case "0399":
                statusMsg =
                  "Invalid authentication at bank (Failed Transaction).";
                statusType = "error";
                break;
              case "0002":
                statusMsg = "Transaction pending. Please check later.";
                statusType = "warning";
                break;
              case "0001":
                statusMsg = "Error at BillDesk. Transaction Cancelled.";
                statusType = "error";
                break;
              default:
                statusMsg = paymentStatus.ErrorDescription || "Payment failed.";
                statusType = "error";
            }

            this.showToast(statusMsg, statusType);

            this.setState({
              jsonDisplay: paymentStatus,
              paymentResultMsg: statusMsg,
              paymentResultType: statusType,
            });
            if (paymentStatus.AuthStatus === "0300") {
              setTimeout(() => {
                this.onSubmitTest();
              }, 5000);
            }
          } catch (err) {
            console.error("PaymentStatus parse error", err);
            this.showToast("Invalid payment response received", "error");
          }
        } else {
          this.showToast(
            data.message || "No policy/payment data found",
            "error"
          );
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load payment status", "error");
      });
  };
  onSubmitTest = (e) => {
    const { jsonDisplay } = this.state;
    if (!jsonDisplay) {
      this.showToast("No payment details available!", "error");
      return;
    }
    const policyId = jsonDisplay.AdditionalInfo1; // policyId
    const premiumAmount = (jsonDisplay.TxnAmount || "0").replace(/^0+/, ""); // remove leading zeros
    const paymentAmount = premiumAmount;
    const transactionDate = jsonDisplay.TxnDate?.split(" ")[0] || ""; // take only date part
    const transactionNo = jsonDisplay.TxnReferenceNo;
    const receiptNo = jsonDisplay.AdditionalInfo3; // receipt no
    const receiptDate = jsonDisplay.TxnDate?.split(" ")[0] || "";
    const jsonData = {
      sourceId: "6128058a-3ff6-4e38-b712-9ed1b8d1d52e",
      policyId: policyId,
      paymentInfo: [
        {
          mode: "online",
          premiumAmount: premiumAmount,
          paymentAmount: paymentAmount,
          transactionDate: transactionDate,
          transactionNo: transactionNo,
          receiptNo: receiptNo,
          receiptDate: receiptDate,
        },
      ],
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 387);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData1));
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ isSuccess: true });
          sessionStorage.setItem("requestIdpayment", data.requestId);
          setTimeout(() => {
            this.createPolicysproposal();
          }, 9000);
        }
      });
    //window.location.href = "/zunoquotes";
  };
  createPolicysproposal = (e) => {
    var formData = new FormData();
    const latestRequestIds = sessionStorage.getItem("requestIdpayment");
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 387);
    formData.append("requestId", latestRequestIds);
    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          if (data.data) {
            if (data.data.status === "error") {
              const errorDesc =
                data.data.exception?.error?.description || "Unknown error";
              this.showToast(errorDesc, "error");
            } else if (data.data.code === 200) {
              if (data.data.status === "POLICY_ALREADY_ISSUED") {
                this.showToast("Policy already issued", "info");
              } else {
                const message = data.data.data?.message || data.data.status;
                this.showToast(message, "success");
              }
              this.setState({
                quotes: data.data,
              });
            } else {
              const message = data.data.message || "Unexpected response";
              this.showToast(message, "warning");
            }
          } else {
            this.showToast("No data received", "error");
          }
        } else {
          const message = data.message || "Request failed";
          this.showToast(message, "error");
        }
      })
      .catch((error) => {
        console.error("Error fetching policy proposal:", error);
      });
  };
  render() {
    const { paymentResultMsg, paymentResultType, jsonDisplay } = this.state;
    let cardBg = "danger"; // default red
    if (paymentResultType === "success") cardBg = "success";
    else if (paymentResultType === "warning") cardBg = "warning";
    return (
      <div>
        <h3 className=" my-3">Zuno Thanks Page</h3>
        <div>
          {paymentResultMsg && jsonDisplay && (
            <Row className="d-flex justify-content-center">
              <Col lg="6" md="8" sm="10">
                {" "}
                {/* Controls card width */}
                <Card
                  bg={cardBg}
                  text={cardBg === "light" ? "dark" : "white"}
                  className="mb-3 shadow"
                >
                  <Card.Header className="text-center">
                    Payment Status
                  </Card.Header>
                  <Card.Body className="text-center">
                    <Card.Title>
                      {paymentResultType === "success"
                        ? "✅ Transaction Successful"
                        : paymentResultType === "error"
                        ? "❌ Transaction Failed"
                        : "⌛ Transaction Pending"}
                    </Card.Title>
                    <Card.Text>
                      <strong>Message:</strong> {paymentResultMsg} <br />
                      <strong>Paid Amount:</strong>{" "}
                      {parseFloat(jsonDisplay.TxnAmount).toFixed(2)}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}
